/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard-api
 * Service for implementing the Rever dashboard
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface FindPaginatedLineItemsResults
 */
export interface FindPaginatedLineItemsResults {
    /**
     * 
     * @type {Array<ModelsPublicReturnLineItem>}
     * @memberof FindPaginatedLineItemsResults
     */
    'line_items'?: Array<ModelsPublicReturnLineItem>;
    /**
     * 
     * @type {string}
     * @memberof FindPaginatedLineItemsResults
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindPaginatedLineItemsResults
     */
    'previous'?: string;
    /**
     * 
     * @type {number}
     * @memberof FindPaginatedLineItemsResults
     */
    'rowcount'?: number;
}
/**
 * 
 * @export
 * @interface ModelsAddress
 */
export interface ModelsAddress {
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'address_line_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'postcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'state_province'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface ModelsComment
 */
export interface ModelsComment {
    /**
     * 
     * @type {string}
     * @memberof ModelsComment
     */
    'comment_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsComment
     */
    'extra'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsComment
     */
    'is_manual'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsComment
     */
    'rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsComment
     */
    'text'?: string;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsComment
     */
    'timestamp'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsComment
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface ModelsCustomer
 */
export interface ModelsCustomer {
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'platform_customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'rever_id'?: string;
}
/**
 * 
 * @export
 * @interface ModelsDimensions
 */
export interface ModelsDimensions {
    /**
     * 
     * @type {number}
     * @memberof ModelsDimensions
     */
    'height_cm'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsDimensions
     */
    'length_cm'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsDimensions
     */
    'width_cm'?: number;
}
/**
 * 
 * @export
 * @interface ModelsLineItemReview
 */
export interface ModelsLineItemReview {
    /**
     * 
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'line_item_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'location_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'reject_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'rever_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsLineItemReview
     */
    'should_restock'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsLineItemReview
     */
    'show_reject_reason'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'status'?: string;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsLineItemReview
     */
    'timestamp'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface ModelsMoneyFormat
 */
export interface ModelsMoneyFormat {
    /**
     * 
     * @type {number}
     * @memberof ModelsMoneyFormat
     */
    'amount_multiplied_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'currency_symbol'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'decimal_separator'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsMoneyFormat
     */
    'display_prices_with_taxes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsMoneyFormat
     */
    'is_currency_left_position'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'thousand_separator'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsMoneyFormat
     */
    'visible_number_of_decimals'?: number;
}
/**
 * 
 * @export
 * @interface ModelsProduct
 */
export interface ModelsProduct {
    /**
     * 
     * @type {string}
     * @memberof ModelsProduct
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ModelsProductImage>}
     * @memberof ModelsProduct
     */
    'images'?: Array<ModelsProductImage>;
    /**
     * 
     * @type {string}
     * @memberof ModelsProduct
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsProduct
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsProduct
     */
    'sku'?: string;
    /**
     * 
     * @type {Array<ModelsProductVariant>}
     * @memberof ModelsProduct
     */
    'variants'?: Array<ModelsProductVariant>;
}
/**
 * 
 * @export
 * @interface ModelsProductImage
 */
export interface ModelsProductImage {
    /**
     * 
     * @type {string}
     * @memberof ModelsProductImage
     */
    'alt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsProductImage
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsProductImage
     */
    'src'?: string;
}
/**
 * 
 * @export
 * @interface ModelsProductVariant
 */
export interface ModelsProductVariant {
    /**
     * 
     * @type {boolean}
     * @memberof ModelsProductVariant
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ModelsProductImage>}
     * @memberof ModelsProductVariant
     */
    'images'?: Array<ModelsProductImage>;
    /**
     * 
     * @type {number}
     * @memberof ModelsProductVariant
     */
    'inventory_quantity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsProductVariant
     */
    'is_inventory_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsProductVariant
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'sku'?: string;
}
/**
 * 
 * @export
 * @interface ModelsPublicReturnLineItem
 */
export interface ModelsPublicReturnLineItem {
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'action'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnLineItem
     */
    'checkout_payment_item'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'comment'?: string;
    /**
     * 
     * @type {StructpbStruct}
     * @memberof ModelsPublicReturnLineItem
     */
    'custom_attributes'?: StructpbStruct;
    /**
     * 
     * @type {ModelsDimensions}
     * @memberof ModelsPublicReturnLineItem
     */
    'dimensions'?: ModelsDimensions;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnLineItem
     */
    'pending_purchase'?: boolean;
    /**
     * 
     * @type {ModelsProduct}
     * @memberof ModelsPublicReturnLineItem
     */
    'product'?: ModelsProduct;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'product_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'product_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'product_return_reason'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'refund_payment_method'?: number;
    /**
     * 
     * @type {ModelsPublicReturnProcess}
     * @memberof ModelsPublicReturnLineItem
     */
    'return_process'?: ModelsPublicReturnProcess;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'return_reason'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'rever_id'?: string;
    /**
     * 
     * @type {Array<ModelsLineItemReview>}
     * @memberof ModelsPublicReturnLineItem
     */
    'reviews'?: Array<ModelsLineItemReview>;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'subtotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'subtype'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'total_discounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'total_taxes'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'unit_price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnLineItem
     */
    'upload_documents_required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'variant_ean'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'variant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnLineItem
     */
    'variant_reference'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnLineItem
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface ModelsPublicReturnProcess
 */
export interface ModelsPublicReturnProcess {
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'ReviewFlow'?: string;
    /**
     * 
     * @type {Array<ModelsRefundActionConfig>}
     * @memberof ModelsPublicReturnProcess
     */
    'action_config'?: Array<ModelsRefundActionConfig>;
    /**
     * 
     * @type {Array<ModelsReturnLineItem>}
     * @memberof ModelsPublicReturnProcess
     */
    'approved_line_items'?: Array<ModelsReturnLineItem>;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'authorization_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'bank_account_country'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'bank_transfer_refund_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'bban'?: string;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsPublicReturnProcess
     */
    'billing_address'?: ModelsAddress;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'canceled_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'carrier_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'checkout_id'?: string;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'collected_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'committed_payment_amount'?: number;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'completed_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'currency'?: string;
    /**
     * 
     * @type {ModelsMoneyFormat}
     * @memberof ModelsPublicReturnProcess
     */
    'currency_money_format'?: ModelsMoneyFormat;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'currency_shop'?: string;
    /**
     * 
     * @type {ModelsCustomer}
     * @memberof ModelsPublicReturnProcess
     */
    'customer'?: ModelsCustomer;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'customer_printed_order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'delivery_note_status'?: string;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsPublicReturnProcess
     */
    'drop_off_address'?: ModelsAddress;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'ecommerce_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'exchange_flow'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'exchange_order_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'exchange_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'exchange_refund_amount'?: number;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsPublicReturnProcess
     */
    'exchange_shipping_address'?: ModelsAddress;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_bank_transfer'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_exchange'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_gift'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_original_pm'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_payment_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_promocode'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'executed_total'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'fraud_model_group'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'fraud_model_outcome'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'fraud_model_score'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnProcess
     */
    'fully_refunded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnProcess
     */
    'fully_returned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'gift_refund_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'group'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'iban'?: string;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsPublicReturnProcess
     */
    'in_store_pickup_address'?: ModelsAddress;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'in_warehouse_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {Array<ModelsComment>}
     * @memberof ModelsPublicReturnProcess
     */
    'internal_comments'?: Array<ModelsComment>;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnProcess
     */
    'is_lite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnProcess
     */
    'is_testing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'keep_your_item_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'last_known_shipping_status'?: number;
    /**
     * 
     * @type {Array<ModelsReturnLineItem>}
     * @memberof ModelsPublicReturnProcess
     */
    'line_items'?: Array<ModelsReturnLineItem>;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'logistic_order_id'?: string;
    /**
     * 
     * @type {StructpbStruct}
     * @memberof ModelsPublicReturnProcess
     */
    'metadata'?: StructpbStruct;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'order_id'?: string;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'order_purchased_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'original_pm_refund_amount'?: number;
    /**
     * 
     * @type {Array<ModelsRefundPaymentMethodConfig>}
     * @memberof ModelsPublicReturnProcess
     */
    'payment_method_config'?: Array<ModelsRefundPaymentMethodConfig>;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'pending_bank_transfer'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'pending_total'?: number;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsPublicReturnProcess
     */
    'pickup_address'?: ModelsAddress;
    /**
     * 
     * @type {Array<number>}
     * @memberof ModelsPublicReturnProcess
     */
    'pickup_ranges'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'platform'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'platform_process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'process_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'promocode_refund_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'refund_timing'?: number;
    /**
     * 
     * @type {Array<ModelsPublicTransaction>}
     * @memberof ModelsPublicReturnProcess
     */
    'refund_transactions'?: Array<ModelsPublicTransaction>;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'refunded_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsPublicReturnProcess
     */
    'return_address'?: ModelsAddress;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'return_method'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'return_status'?: string;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'returned_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'returned_total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'returns_committed'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'returns_pending'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnProcess
     */
    'review_available'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'start_return_on_platform_time'?: number;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicReturnProcess
     */
    'started_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'swift'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicReturnProcess
     */
    'total_refund_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'tracking_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'tracking_url'?: string;
    /**
     * 
     * @type {Array<ModelsTransaction>}
     * @memberof ModelsPublicReturnProcess
     */
    'transactions'?: Array<ModelsTransaction>;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsPublicReturnProcess
     */
    'upload_documents_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'user_preferred_lang'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'user_selected_carrier'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'user_selected_provider'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicReturnProcess
     */
    'warehouse_id'?: string;
}
/**
 * 
 * @export
 * @interface ModelsPublicTransaction
 */
export interface ModelsPublicTransaction {
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicTransaction
     */
    'amount'?: number;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicTransaction
     */
    'created_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'currency'?: string;
    /**
     * 
     * @type {ModelsMoneyFormat}
     * @memberof ModelsPublicTransaction
     */
    'currency_money_format'?: ModelsMoneyFormat;
    /**
     * 
     * @type {StructpbStruct}
     * @memberof ModelsPublicTransaction
     */
    'metadata'?: StructpbStruct;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'parent_transaction_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'platform_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'process_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicTransaction
     */
    'provider'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicTransaction
     */
    'refund_payment_method'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'rever_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicTransaction
     */
    'status'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsPublicTransaction
     */
    'type'?: number;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsPublicTransaction
     */
    'updated_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsPublicTransaction
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface ModelsRefundActionConfig
 */
export interface ModelsRefundActionConfig {
    /**
     * 
     * @type {number}
     * @memberof ModelsRefundActionConfig
     */
    'name'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundActionConfig
     */
    'rever_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsRefundActionConfig
     */
    'timing'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModelsRefundActionConfig
     */
    'when'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ModelsRefundPaymentMethodConfig
 */
export interface ModelsRefundPaymentMethodConfig {
    /**
     * 
     * @type {number}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'name'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'rever_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'timing'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'when'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ModelsReturnLineItem
 */
export interface ModelsReturnLineItem {
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'action'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsReturnLineItem
     */
    'checkout_payment_item'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'comment'?: string;
    /**
     * 
     * @type {StructpbStruct}
     * @memberof ModelsReturnLineItem
     */
    'custom_attributes'?: StructpbStruct;
    /**
     * 
     * @type {ModelsDimensions}
     * @memberof ModelsReturnLineItem
     */
    'dimensions'?: ModelsDimensions;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsReturnLineItem
     */
    'pending_purchase'?: boolean;
    /**
     * 
     * @type {ModelsProduct}
     * @memberof ModelsReturnLineItem
     */
    'product'?: ModelsProduct;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_return_reason'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'refund_payment_method'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'return_reason'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'rever_id'?: string;
    /**
     * 
     * @type {Array<ModelsLineItemReview>}
     * @memberof ModelsReturnLineItem
     */
    'reviews'?: Array<ModelsLineItemReview>;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'subtotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'subtype'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'total_discounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'total_taxes'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'unit_price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsReturnLineItem
     */
    'upload_documents_required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_ean'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_reference'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface ModelsTransaction
 */
export interface ModelsTransaction {
    /**
     * 
     * @type {number}
     * @memberof ModelsTransaction
     */
    'amount'?: number;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsTransaction
     */
    'created_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'currency'?: string;
    /**
     * 
     * @type {StructpbStruct}
     * @memberof ModelsTransaction
     */
    'metadata'?: StructpbStruct;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'parent_transaction_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'platform_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'process_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsTransaction
     */
    'provider'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsTransaction
     */
    'refund_payment_method'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'rever_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsTransaction
     */
    'status'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsTransaction
     */
    'type'?: number;
    /**
     * 
     * @type {TimestamppbTimestamp}
     * @memberof ModelsTransaction
     */
    'updated_at'?: TimestamppbTimestamp;
    /**
     * 
     * @type {string}
     * @memberof ModelsTransaction
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface ProcessessapiCountryISO
 */
export interface ProcessessapiCountryISO {
    /**
     * 
     * @type {string}
     * @memberof ProcessessapiCountryISO
     */
    'iso'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessessapiCountryISO
     */
    'iso_3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessessapiCountryISO
     */
    'localname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessessapiCountryISO
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessessapiCountryISO
     */
    'nicename'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessessapiCountryISO
     */
    'numcode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessessapiCountryISO
     */
    'phonecode'?: number | null;
}
/**
 * 
 * @export
 * @interface RestPaginatedResults
 */
export interface RestPaginatedResults {
    /**
     * 
     * @type {string}
     * @memberof RestPaginatedResults
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof RestPaginatedResults
     */
    'previous'?: string;
    /**
     * 
     * @type {Array<ModelsPublicReturnProcess>}
     * @memberof RestPaginatedResults
     */
    'processes'?: Array<ModelsPublicReturnProcess>;
    /**
     * 
     * @type {number}
     * @memberof RestPaginatedResults
     */
    'rowcount'?: number;
}
/**
 * 
 * @export
 * @interface StructpbStruct
 */
export interface StructpbStruct {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof StructpbStruct
     */
    'fields'?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface TimestamppbTimestamp
 */
export interface TimestamppbTimestamp {
    /**
     * 
     * @type {number}
     * @memberof TimestamppbTimestamp
     */
    'nanos'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimestamppbTimestamp
     */
    'seconds'?: number;
}

/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves all of the countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/locations/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves all of the countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessessapiCountryISO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.findCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves all of the countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessessapiCountryISO>> {
            return localVarFp.findCountries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @summary Retrieves all of the countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public findCountries(options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).findCountries(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessesApi - axios parameter creator
 * @export
 */
export const ProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves return line items by several filters in export format, freetext search and pagination
         * @param {string} [customerPrintedOrderId] filter processes by customer_printed_order_id value. Default: no filtering
         * @param {string} [ecommerceId] e-commerce ID (or multiple separated by ,)
         * @param {string} [freetext] open text search
         * @param {string} [fullyRefunded] if fully_refunded should be true or false. Default: no filtering
         * @param {string} [lastKnownShippingStatus] Filter processes by LastKnownShippingStatus value (NO_SHIPPING_STATUS, CREATED, COLLECTED, IN_WAREHOUSE, ERROR, CANCELED). Default: no filtering
         * @param {number} [limit] maximum number of results. Default value is 20
         * @param {string} [lineItemReturnReason] Filter by return reason, (or multiple separated by ,)
         * @param {string} [lineItemsReviewsStatus] Filter by review status, (or multiple separated by ,)
         * @param {string} [lineItemsId] Filter processes by reverID
         * @param {number} [offset] items offset
         * @param {string} [order] order direction: ASC or DESC
         * @param {string} [orderId] filter processes by order_id value. Default: no filtering
         * @param {string} [platform] filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
         * @param {string} [processId] filter processes by process_id value. Default: no filtering
         * @param {string} [returnMethod] filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
         * @param {string} [returnStatus] filter for return status (or multiple separated by ,)
         * @param {boolean} [reviewAvailable] Filter by review availability
         * @param {string} [sortby] sort column
         * @param {string} [startedAtGte] Filter by started_at gte
         * @param {string} [startedAtLte] Filter by started_at lte
         * @param {string} [status] Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findExportLineItems: async (customerPrintedOrderId?: string, ecommerceId?: string, freetext?: string, fullyRefunded?: string, lastKnownShippingStatus?: string, limit?: number, lineItemReturnReason?: string, lineItemsReviewsStatus?: string, lineItemsId?: string, offset?: number, order?: string, orderId?: string, platform?: string, processId?: string, returnMethod?: string, returnStatus?: string, reviewAvailable?: boolean, sortby?: string, startedAtGte?: string, startedAtLte?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/processes/line_items_export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerPrintedOrderId !== undefined) {
                localVarQueryParameter['customer_printed_order_id'] = customerPrintedOrderId;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (freetext !== undefined) {
                localVarQueryParameter['freetext'] = freetext;
            }

            if (fullyRefunded !== undefined) {
                localVarQueryParameter['fully_refunded'] = fullyRefunded;
            }

            if (lastKnownShippingStatus !== undefined) {
                localVarQueryParameter['last_known_shipping_status'] = lastKnownShippingStatus;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (lineItemReturnReason !== undefined) {
                localVarQueryParameter['line_item_return_reason'] = lineItemReturnReason;
            }

            if (lineItemsReviewsStatus !== undefined) {
                localVarQueryParameter['line_items.reviews.status'] = lineItemsReviewsStatus;
            }

            if (lineItemsId !== undefined) {
                localVarQueryParameter['line_items_id'] = lineItemsId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order_id'] = orderId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (processId !== undefined) {
                localVarQueryParameter['process_id'] = processId;
            }

            if (returnMethod !== undefined) {
                localVarQueryParameter['return_method'] = returnMethod;
            }

            if (returnStatus !== undefined) {
                localVarQueryParameter['return_status'] = returnStatus;
            }

            if (reviewAvailable !== undefined) {
                localVarQueryParameter['review_available'] = reviewAvailable;
            }

            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }

            if (startedAtGte !== undefined) {
                localVarQueryParameter['started_at.gte'] = startedAtGte;
            }

            if (startedAtLte !== undefined) {
                localVarQueryParameter['started_at.lte'] = startedAtLte;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves return line items by several filters, freetext search and pagination
         * @param {string} [customerPrintedOrderId] filter processes by customer_printed_order_id value. Default: no filtering
         * @param {string} [ecommerceId] e-commerce ID (or multiple separated by ,)
         * @param {string} [freetext] open text search
         * @param {string} [fullyRefunded] if fully_refunded should be true or false. Default: no filtering
         * @param {string} [lastKnownShippingStatus] Filter processes by LastKnownShippingStatus value (NO_SHIPPING_STATUS, CREATED, COLLECTED, IN_WAREHOUSE, ERROR, CANCELED). Default: no filtering
         * @param {number} [limit] maximum number of results. Default value is 20
         * @param {string} [lineItemReturnReason] Filter by return reason, (or multiple separated by ,)
         * @param {string} [lineItemsReviewsStatus] Filter by review status, (or multiple separated by ,)
         * @param {string} [lineItemsId] Filter processes by reverID
         * @param {number} [offset] items offset
         * @param {string} [order] order direction: ASC or DESC
         * @param {string} [orderId] filter processes by order_id value. Default: no filtering
         * @param {string} [platform] filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
         * @param {string} [processId] filter processes by process_id value. Default: no filtering
         * @param {string} [returnMethod] filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
         * @param {string} [returnStatus] filter for return status (or multiple separated by ,)
         * @param {boolean} [reviewAvailable] Filter by review availability
         * @param {string} [sortby] sort column
         * @param {string} [startedAtGte] Filter by started_at gte
         * @param {string} [startedAtLte] Filter by started_at lte
         * @param {string} [status] Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLineItems: async (customerPrintedOrderId?: string, ecommerceId?: string, freetext?: string, fullyRefunded?: string, lastKnownShippingStatus?: string, limit?: number, lineItemReturnReason?: string, lineItemsReviewsStatus?: string, lineItemsId?: string, offset?: number, order?: string, orderId?: string, platform?: string, processId?: string, returnMethod?: string, returnStatus?: string, reviewAvailable?: boolean, sortby?: string, startedAtGte?: string, startedAtLte?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/processes/line_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerPrintedOrderId !== undefined) {
                localVarQueryParameter['customer_printed_order_id'] = customerPrintedOrderId;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (freetext !== undefined) {
                localVarQueryParameter['freetext'] = freetext;
            }

            if (fullyRefunded !== undefined) {
                localVarQueryParameter['fully_refunded'] = fullyRefunded;
            }

            if (lastKnownShippingStatus !== undefined) {
                localVarQueryParameter['last_known_shipping_status'] = lastKnownShippingStatus;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (lineItemReturnReason !== undefined) {
                localVarQueryParameter['line_item_return_reason'] = lineItemReturnReason;
            }

            if (lineItemsReviewsStatus !== undefined) {
                localVarQueryParameter['line_items.reviews.status'] = lineItemsReviewsStatus;
            }

            if (lineItemsId !== undefined) {
                localVarQueryParameter['line_items_id'] = lineItemsId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order_id'] = orderId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (processId !== undefined) {
                localVarQueryParameter['process_id'] = processId;
            }

            if (returnMethod !== undefined) {
                localVarQueryParameter['return_method'] = returnMethod;
            }

            if (returnStatus !== undefined) {
                localVarQueryParameter['return_status'] = returnStatus;
            }

            if (reviewAvailable !== undefined) {
                localVarQueryParameter['review_available'] = reviewAvailable;
            }

            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }

            if (startedAtGte !== undefined) {
                localVarQueryParameter['started_at.gte'] = startedAtGte;
            }

            if (startedAtLte !== undefined) {
                localVarQueryParameter['started_at.lte'] = startedAtLte;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves return processes by several filters, freetext search and pagination
         * @param {number} [bankTransferRefundAmountGt] filter processes by bank_transfer_refund_amount greater than value. Default: no filtering
         * @param {string} [createdAtGte] filter processes by created_at greater than or equal to value. Default: no filtering
         * @param {string} [createdAtLte] filter processes by created_at less than or equal to value. Default: no filtering
         * @param {string} [customerPrintedOrderId] filter processes by customer_printed_order_id value. Default: no filtering
         * @param {string} [ecommerceId] e-commerce ID (or multiple separated by ,)
         * @param {number} [exchangeRefundAmountGt] filter processes by exchange_refund_amount greater than value. Default: no filtering
         * @param {string} [freetext] open text search
         * @param {string} [fullyRefunded] if fully_refunded should be true or false. Default: no filtering
         * @param {number} [giftRefundAmountGt] filter processes by gift_refund_amount greater than value. Default: no filtering
         * @param {number} [limit] maximum number of results. Default value is 20
         * @param {number} [offset] items offset
         * @param {string} [order] order direction: ASC or DESC
         * @param {string} [orderId] filter processes by order_id value. Default: no filtering
         * @param {number} [originalPmRefundAmountGt] filter processes by original_pm_refund_amount greater than value. Default: no filtering
         * @param {string} [platform] filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
         * @param {string} [processId] filter processes by process_id value. Default: no filtering
         * @param {number} [promocodeRefundAmountGt] filter processes by promocode_refund_amount greater than value. Default: no filtering
         * @param {string} [returnMethod] filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
         * @param {string} [returnStatus] return status (or multiple separated by ,)
         * @param {string} [sortby] sort column
         * @param {string} [status] Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcesses: async (bankTransferRefundAmountGt?: number, createdAtGte?: string, createdAtLte?: string, customerPrintedOrderId?: string, ecommerceId?: string, exchangeRefundAmountGt?: number, freetext?: string, fullyRefunded?: string, giftRefundAmountGt?: number, limit?: number, offset?: number, order?: string, orderId?: string, originalPmRefundAmountGt?: number, platform?: string, processId?: string, promocodeRefundAmountGt?: number, returnMethod?: string, returnStatus?: string, sortby?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/processes/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bankTransferRefundAmountGt !== undefined) {
                localVarQueryParameter['bank_transfer_refund_amount.gt'] = bankTransferRefundAmountGt;
            }

            if (createdAtGte !== undefined) {
                localVarQueryParameter['created_at.gte'] = createdAtGte;
            }

            if (createdAtLte !== undefined) {
                localVarQueryParameter['created_at.lte'] = createdAtLte;
            }

            if (customerPrintedOrderId !== undefined) {
                localVarQueryParameter['customer_printed_order_id'] = customerPrintedOrderId;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (exchangeRefundAmountGt !== undefined) {
                localVarQueryParameter['exchange_refund_amount.gt'] = exchangeRefundAmountGt;
            }

            if (freetext !== undefined) {
                localVarQueryParameter['freetext'] = freetext;
            }

            if (fullyRefunded !== undefined) {
                localVarQueryParameter['fully_refunded'] = fullyRefunded;
            }

            if (giftRefundAmountGt !== undefined) {
                localVarQueryParameter['gift_refund_amount.gt'] = giftRefundAmountGt;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order_id'] = orderId;
            }

            if (originalPmRefundAmountGt !== undefined) {
                localVarQueryParameter['original_pm_refund_amount.gt'] = originalPmRefundAmountGt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (processId !== undefined) {
                localVarQueryParameter['process_id'] = processId;
            }

            if (promocodeRefundAmountGt !== undefined) {
                localVarQueryParameter['promocode_refund_amount.gt'] = promocodeRefundAmountGt;
            }

            if (returnMethod !== undefined) {
                localVarQueryParameter['return_method'] = returnMethod;
            }

            if (returnStatus !== undefined) {
                localVarQueryParameter['return_status'] = returnStatus;
            }

            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesApi - functional programming interface
 * @export
 */
export const ProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves return line items by several filters in export format, freetext search and pagination
         * @param {string} [customerPrintedOrderId] filter processes by customer_printed_order_id value. Default: no filtering
         * @param {string} [ecommerceId] e-commerce ID (or multiple separated by ,)
         * @param {string} [freetext] open text search
         * @param {string} [fullyRefunded] if fully_refunded should be true or false. Default: no filtering
         * @param {string} [lastKnownShippingStatus] Filter processes by LastKnownShippingStatus value (NO_SHIPPING_STATUS, CREATED, COLLECTED, IN_WAREHOUSE, ERROR, CANCELED). Default: no filtering
         * @param {number} [limit] maximum number of results. Default value is 20
         * @param {string} [lineItemReturnReason] Filter by return reason, (or multiple separated by ,)
         * @param {string} [lineItemsReviewsStatus] Filter by review status, (or multiple separated by ,)
         * @param {string} [lineItemsId] Filter processes by reverID
         * @param {number} [offset] items offset
         * @param {string} [order] order direction: ASC or DESC
         * @param {string} [orderId] filter processes by order_id value. Default: no filtering
         * @param {string} [platform] filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
         * @param {string} [processId] filter processes by process_id value. Default: no filtering
         * @param {string} [returnMethod] filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
         * @param {string} [returnStatus] filter for return status (or multiple separated by ,)
         * @param {boolean} [reviewAvailable] Filter by review availability
         * @param {string} [sortby] sort column
         * @param {string} [startedAtGte] Filter by started_at gte
         * @param {string} [startedAtLte] Filter by started_at lte
         * @param {string} [status] Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findExportLineItems(customerPrintedOrderId?: string, ecommerceId?: string, freetext?: string, fullyRefunded?: string, lastKnownShippingStatus?: string, limit?: number, lineItemReturnReason?: string, lineItemsReviewsStatus?: string, lineItemsId?: string, offset?: number, order?: string, orderId?: string, platform?: string, processId?: string, returnMethod?: string, returnStatus?: string, reviewAvailable?: boolean, sortby?: string, startedAtGte?: string, startedAtLte?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findExportLineItems(customerPrintedOrderId, ecommerceId, freetext, fullyRefunded, lastKnownShippingStatus, limit, lineItemReturnReason, lineItemsReviewsStatus, lineItemsId, offset, order, orderId, platform, processId, returnMethod, returnStatus, reviewAvailable, sortby, startedAtGte, startedAtLte, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findExportLineItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves return line items by several filters, freetext search and pagination
         * @param {string} [customerPrintedOrderId] filter processes by customer_printed_order_id value. Default: no filtering
         * @param {string} [ecommerceId] e-commerce ID (or multiple separated by ,)
         * @param {string} [freetext] open text search
         * @param {string} [fullyRefunded] if fully_refunded should be true or false. Default: no filtering
         * @param {string} [lastKnownShippingStatus] Filter processes by LastKnownShippingStatus value (NO_SHIPPING_STATUS, CREATED, COLLECTED, IN_WAREHOUSE, ERROR, CANCELED). Default: no filtering
         * @param {number} [limit] maximum number of results. Default value is 20
         * @param {string} [lineItemReturnReason] Filter by return reason, (or multiple separated by ,)
         * @param {string} [lineItemsReviewsStatus] Filter by review status, (or multiple separated by ,)
         * @param {string} [lineItemsId] Filter processes by reverID
         * @param {number} [offset] items offset
         * @param {string} [order] order direction: ASC or DESC
         * @param {string} [orderId] filter processes by order_id value. Default: no filtering
         * @param {string} [platform] filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
         * @param {string} [processId] filter processes by process_id value. Default: no filtering
         * @param {string} [returnMethod] filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
         * @param {string} [returnStatus] filter for return status (or multiple separated by ,)
         * @param {boolean} [reviewAvailable] Filter by review availability
         * @param {string} [sortby] sort column
         * @param {string} [startedAtGte] Filter by started_at gte
         * @param {string} [startedAtLte] Filter by started_at lte
         * @param {string} [status] Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLineItems(customerPrintedOrderId?: string, ecommerceId?: string, freetext?: string, fullyRefunded?: string, lastKnownShippingStatus?: string, limit?: number, lineItemReturnReason?: string, lineItemsReviewsStatus?: string, lineItemsId?: string, offset?: number, order?: string, orderId?: string, platform?: string, processId?: string, returnMethod?: string, returnStatus?: string, reviewAvailable?: boolean, sortby?: string, startedAtGte?: string, startedAtLte?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindPaginatedLineItemsResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLineItems(customerPrintedOrderId, ecommerceId, freetext, fullyRefunded, lastKnownShippingStatus, limit, lineItemReturnReason, lineItemsReviewsStatus, lineItemsId, offset, order, orderId, platform, processId, returnMethod, returnStatus, reviewAvailable, sortby, startedAtGte, startedAtLte, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findLineItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves return processes by several filters, freetext search and pagination
         * @param {number} [bankTransferRefundAmountGt] filter processes by bank_transfer_refund_amount greater than value. Default: no filtering
         * @param {string} [createdAtGte] filter processes by created_at greater than or equal to value. Default: no filtering
         * @param {string} [createdAtLte] filter processes by created_at less than or equal to value. Default: no filtering
         * @param {string} [customerPrintedOrderId] filter processes by customer_printed_order_id value. Default: no filtering
         * @param {string} [ecommerceId] e-commerce ID (or multiple separated by ,)
         * @param {number} [exchangeRefundAmountGt] filter processes by exchange_refund_amount greater than value. Default: no filtering
         * @param {string} [freetext] open text search
         * @param {string} [fullyRefunded] if fully_refunded should be true or false. Default: no filtering
         * @param {number} [giftRefundAmountGt] filter processes by gift_refund_amount greater than value. Default: no filtering
         * @param {number} [limit] maximum number of results. Default value is 20
         * @param {number} [offset] items offset
         * @param {string} [order] order direction: ASC or DESC
         * @param {string} [orderId] filter processes by order_id value. Default: no filtering
         * @param {number} [originalPmRefundAmountGt] filter processes by original_pm_refund_amount greater than value. Default: no filtering
         * @param {string} [platform] filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
         * @param {string} [processId] filter processes by process_id value. Default: no filtering
         * @param {number} [promocodeRefundAmountGt] filter processes by promocode_refund_amount greater than value. Default: no filtering
         * @param {string} [returnMethod] filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
         * @param {string} [returnStatus] return status (or multiple separated by ,)
         * @param {string} [sortby] sort column
         * @param {string} [status] Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProcesses(bankTransferRefundAmountGt?: number, createdAtGte?: string, createdAtLte?: string, customerPrintedOrderId?: string, ecommerceId?: string, exchangeRefundAmountGt?: number, freetext?: string, fullyRefunded?: string, giftRefundAmountGt?: number, limit?: number, offset?: number, order?: string, orderId?: string, originalPmRefundAmountGt?: number, platform?: string, processId?: string, promocodeRefundAmountGt?: number, returnMethod?: string, returnStatus?: string, sortby?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestPaginatedResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProcesses(bankTransferRefundAmountGt, createdAtGte, createdAtLte, customerPrintedOrderId, ecommerceId, exchangeRefundAmountGt, freetext, fullyRefunded, giftRefundAmountGt, limit, offset, order, orderId, originalPmRefundAmountGt, platform, processId, promocodeRefundAmountGt, returnMethod, returnStatus, sortby, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesApi - factory interface
 * @export
 */
export const ProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves return line items by several filters in export format, freetext search and pagination
         * @param {ProcessesApiFindExportLineItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findExportLineItems(requestParameters: ProcessesApiFindExportLineItemsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.findExportLineItems(requestParameters.customerPrintedOrderId, requestParameters.ecommerceId, requestParameters.freetext, requestParameters.fullyRefunded, requestParameters.lastKnownShippingStatus, requestParameters.limit, requestParameters.lineItemReturnReason, requestParameters.lineItemsReviewsStatus, requestParameters.lineItemsId, requestParameters.offset, requestParameters.order, requestParameters.orderId, requestParameters.platform, requestParameters.processId, requestParameters.returnMethod, requestParameters.returnStatus, requestParameters.reviewAvailable, requestParameters.sortby, requestParameters.startedAtGte, requestParameters.startedAtLte, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves return line items by several filters, freetext search and pagination
         * @param {ProcessesApiFindLineItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLineItems(requestParameters: ProcessesApiFindLineItemsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FindPaginatedLineItemsResults> {
            return localVarFp.findLineItems(requestParameters.customerPrintedOrderId, requestParameters.ecommerceId, requestParameters.freetext, requestParameters.fullyRefunded, requestParameters.lastKnownShippingStatus, requestParameters.limit, requestParameters.lineItemReturnReason, requestParameters.lineItemsReviewsStatus, requestParameters.lineItemsId, requestParameters.offset, requestParameters.order, requestParameters.orderId, requestParameters.platform, requestParameters.processId, requestParameters.returnMethod, requestParameters.returnStatus, requestParameters.reviewAvailable, requestParameters.sortby, requestParameters.startedAtGte, requestParameters.startedAtLte, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves return processes by several filters, freetext search and pagination
         * @param {ProcessesApiFindProcessesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcesses(requestParameters: ProcessesApiFindProcessesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RestPaginatedResults> {
            return localVarFp.findProcesses(requestParameters.bankTransferRefundAmountGt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.customerPrintedOrderId, requestParameters.ecommerceId, requestParameters.exchangeRefundAmountGt, requestParameters.freetext, requestParameters.fullyRefunded, requestParameters.giftRefundAmountGt, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.orderId, requestParameters.originalPmRefundAmountGt, requestParameters.platform, requestParameters.processId, requestParameters.promocodeRefundAmountGt, requestParameters.returnMethod, requestParameters.returnStatus, requestParameters.sortby, requestParameters.status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findExportLineItems operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindExportLineItemsRequest
 */
export interface ProcessesApiFindExportLineItemsRequest {
    /**
     * filter processes by customer_printed_order_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly customerPrintedOrderId?: string

    /**
     * e-commerce ID (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly ecommerceId?: string

    /**
     * open text search
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly freetext?: string

    /**
     * if fully_refunded should be true or false. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly fullyRefunded?: string

    /**
     * Filter processes by LastKnownShippingStatus value (NO_SHIPPING_STATUS, CREATED, COLLECTED, IN_WAREHOUSE, ERROR, CANCELED). Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly lastKnownShippingStatus?: string

    /**
     * maximum number of results. Default value is 20
     * @type {number}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly limit?: number

    /**
     * Filter by return reason, (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly lineItemReturnReason?: string

    /**
     * Filter by review status, (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly lineItemsReviewsStatus?: string

    /**
     * Filter processes by reverID
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly lineItemsId?: string

    /**
     * items offset
     * @type {number}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly offset?: number

    /**
     * order direction: ASC or DESC
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly order?: string

    /**
     * filter processes by order_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly orderId?: string

    /**
     * filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly platform?: string

    /**
     * filter processes by process_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly processId?: string

    /**
     * filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly returnMethod?: string

    /**
     * filter for return status (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly returnStatus?: string

    /**
     * Filter by review availability
     * @type {boolean}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly reviewAvailable?: boolean

    /**
     * sort column
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly sortby?: string

    /**
     * Filter by started_at gte
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly startedAtGte?: string

    /**
     * Filter by started_at lte
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly startedAtLte?: string

    /**
     * Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindExportLineItems
     */
    readonly status?: string
}

/**
 * Request parameters for findLineItems operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindLineItemsRequest
 */
export interface ProcessesApiFindLineItemsRequest {
    /**
     * filter processes by customer_printed_order_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly customerPrintedOrderId?: string

    /**
     * e-commerce ID (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly ecommerceId?: string

    /**
     * open text search
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly freetext?: string

    /**
     * if fully_refunded should be true or false. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly fullyRefunded?: string

    /**
     * Filter processes by LastKnownShippingStatus value (NO_SHIPPING_STATUS, CREATED, COLLECTED, IN_WAREHOUSE, ERROR, CANCELED). Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly lastKnownShippingStatus?: string

    /**
     * maximum number of results. Default value is 20
     * @type {number}
     * @memberof ProcessesApiFindLineItems
     */
    readonly limit?: number

    /**
     * Filter by return reason, (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly lineItemReturnReason?: string

    /**
     * Filter by review status, (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly lineItemsReviewsStatus?: string

    /**
     * Filter processes by reverID
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly lineItemsId?: string

    /**
     * items offset
     * @type {number}
     * @memberof ProcessesApiFindLineItems
     */
    readonly offset?: number

    /**
     * order direction: ASC or DESC
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly order?: string

    /**
     * filter processes by order_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly orderId?: string

    /**
     * filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly platform?: string

    /**
     * filter processes by process_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly processId?: string

    /**
     * filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly returnMethod?: string

    /**
     * filter for return status (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly returnStatus?: string

    /**
     * Filter by review availability
     * @type {boolean}
     * @memberof ProcessesApiFindLineItems
     */
    readonly reviewAvailable?: boolean

    /**
     * sort column
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly sortby?: string

    /**
     * Filter by started_at gte
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly startedAtGte?: string

    /**
     * Filter by started_at lte
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly startedAtLte?: string

    /**
     * Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindLineItems
     */
    readonly status?: string
}

/**
 * Request parameters for findProcesses operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindProcessesRequest
 */
export interface ProcessesApiFindProcessesRequest {
    /**
     * filter processes by bank_transfer_refund_amount greater than value. Default: no filtering
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly bankTransferRefundAmountGt?: number

    /**
     * filter processes by created_at greater than or equal to value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly createdAtGte?: string

    /**
     * filter processes by created_at less than or equal to value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly createdAtLte?: string

    /**
     * filter processes by customer_printed_order_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly customerPrintedOrderId?: string

    /**
     * e-commerce ID (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly ecommerceId?: string

    /**
     * filter processes by exchange_refund_amount greater than value. Default: no filtering
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly exchangeRefundAmountGt?: number

    /**
     * open text search
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly freetext?: string

    /**
     * if fully_refunded should be true or false. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly fullyRefunded?: string

    /**
     * filter processes by gift_refund_amount greater than value. Default: no filtering
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly giftRefundAmountGt?: number

    /**
     * maximum number of results. Default value is 20
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly limit?: number

    /**
     * items offset
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly offset?: number

    /**
     * order direction: ASC or DESC
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly order?: string

    /**
     * filter processes by order_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly orderId?: string

    /**
     * filter processes by original_pm_refund_amount greater than value. Default: no filtering
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly originalPmRefundAmountGt?: number

    /**
     * filter processes by platform value (SHOPIFY, MOCK, MAGENTO....) Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly platform?: string

    /**
     * filter processes by process_id value. Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly processId?: string

    /**
     * filter processes by promocode_refund_amount greater than value. Default: no filtering
     * @type {number}
     * @memberof ProcessesApiFindProcesses
     */
    readonly promocodeRefundAmountGt?: number

    /**
     * filter processes by return_method value (HOME_PICK_UP, DROP_OFF_POINT) Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly returnMethod?: string

    /**
     * return status (or multiple separated by ,)
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly returnStatus?: string

    /**
     * sort column
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly sortby?: string

    /**
     * Filter processes by status value (RUNNING, FAILED, COMPLETED). Default: no filtering
     * @type {string}
     * @memberof ProcessesApiFindProcesses
     */
    readonly status?: string
}

/**
 * ProcessesApi - object-oriented interface
 * @export
 * @class ProcessesApi
 * @extends {BaseAPI}
 */
export class ProcessesApi extends BaseAPI {
    /**
     * 
     * @summary Retrieves return line items by several filters in export format, freetext search and pagination
     * @param {ProcessesApiFindExportLineItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findExportLineItems(requestParameters: ProcessesApiFindExportLineItemsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findExportLineItems(requestParameters.customerPrintedOrderId, requestParameters.ecommerceId, requestParameters.freetext, requestParameters.fullyRefunded, requestParameters.lastKnownShippingStatus, requestParameters.limit, requestParameters.lineItemReturnReason, requestParameters.lineItemsReviewsStatus, requestParameters.lineItemsId, requestParameters.offset, requestParameters.order, requestParameters.orderId, requestParameters.platform, requestParameters.processId, requestParameters.returnMethod, requestParameters.returnStatus, requestParameters.reviewAvailable, requestParameters.sortby, requestParameters.startedAtGte, requestParameters.startedAtLte, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves return line items by several filters, freetext search and pagination
     * @param {ProcessesApiFindLineItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findLineItems(requestParameters: ProcessesApiFindLineItemsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findLineItems(requestParameters.customerPrintedOrderId, requestParameters.ecommerceId, requestParameters.freetext, requestParameters.fullyRefunded, requestParameters.lastKnownShippingStatus, requestParameters.limit, requestParameters.lineItemReturnReason, requestParameters.lineItemsReviewsStatus, requestParameters.lineItemsId, requestParameters.offset, requestParameters.order, requestParameters.orderId, requestParameters.platform, requestParameters.processId, requestParameters.returnMethod, requestParameters.returnStatus, requestParameters.reviewAvailable, requestParameters.sortby, requestParameters.startedAtGte, requestParameters.startedAtLte, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves return processes by several filters, freetext search and pagination
     * @param {ProcessesApiFindProcessesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findProcesses(requestParameters: ProcessesApiFindProcessesRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findProcesses(requestParameters.bankTransferRefundAmountGt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.customerPrintedOrderId, requestParameters.ecommerceId, requestParameters.exchangeRefundAmountGt, requestParameters.freetext, requestParameters.fullyRefunded, requestParameters.giftRefundAmountGt, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.orderId, requestParameters.originalPmRefundAmountGt, requestParameters.platform, requestParameters.processId, requestParameters.promocodeRefundAmountGt, requestParameters.returnMethod, requestParameters.returnStatus, requestParameters.sortby, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
}



